// ----------------------------------------------------------------------
export const Paper = () => {
    return {
        MuiPaper: {
            styleOverrides: {
            // rounded: { borderRadius: theme.shape.borderRadiusMd }
            }
        }
    };
};
//# sourceMappingURL=Paper.js.map